import styled from 'styled-components';
import { Checkbox as SemanticCheckbox } from 'semantic-ui-react';
import { Header, Loader as LoaderLayoutComponent } from '@playbookux/playbook-web-core';

export const Table = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TableHeader = styled.div`
  display: flex;
  align-items: baseline;
`;

export const TableHeaderCategoryTitle = styled(Header)`
  && {
    flex: 1;
    font-weight: 500;
    padding-left: 20px;
  }
`;

export const TableHeaderTitle = styled(Header)`
  flex: 1;
  font-weight: 500;
  &&& {
    ${(props) => props.paddingLeft && 'padding-left: 20px;'};
  }
`;

export const CheckboxTitle = styled(SemanticCheckbox)`
  &&.ui.checkbox {
    label {
      font-size: 1.28571429em;
      font-family: 'Roboto';
      font-weight: 500;
      color: rgba(0,0,0,.87);
    }
  }
`;

export const ContainerLoader = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

export const Loader = styled(LoaderLayoutComponent)``;
